<template>
    <!-- Загрузка: скелет меню вместо пустого экрана — страница «появляется» быстрее -->
    <div v-if="$store.state.loading" class="boot" aria-busy="true" :aria-label="$t('word147')">
        <div class="boot__cover sk"></div>
        <div class="boot__id">
            <div class="boot__logo sk"></div>
            <div class="boot__lines"><i class="sk" style="width:62%"></i><i class="sk" style="width:38%"></i></div>
        </div>
        <div class="boot__chips"><i class="sk"></i><i class="sk"></i><i class="sk"></i></div>
        <div class="boot__grid">
            <div v-for="n in 4" :key="n"><i class="sk boot__ph"></i><i class="sk" style="width:80%"></i><i class="sk" style="width:45%"></i></div>
        </div>
    </div>

    <!-- Меню отключено (подписка заведения истекла) -->
    <div v-if="$store.state.expired" class="state">
        <svg class="state__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <rect x="4.5" y="10.5" width="15" height="10" rx="2.5"/><path d="M8 10.5V7.5a4 4 0 0 1 8 0v3"/><path d="M12 14.5v2.5"/>
        </svg>
        <h1>{{ $t('word140') }}</h1>
        <p>{{ $t('word141') }}</p>
    </div>

    <!-- Неизвестный адрес -->
    <div v-if="$store.state.not_found" class="state">
        <p class="state__code">404</p>
        <p>{{ $t('word139') }}</p>
        <a class="y-btn y-petal state__btn" href="https://yola.menu">Yola Menu</a>
    </div>

    <router-view/>
</template>

<script>

export default {
   
    data() {
        return {
           
        }
    },
   
    mounted() {
        if (window.location.pathname != '/') {
            this.$store.commit("setVendorCode", window.location.pathname.split('/')[1]); 
            localStorage.getItem("currentLang")&&this.$store.commit("setCurrentLang",localStorage.getItem("currentLang"));      
            this.$store.dispatch('GET_VENDOR_FROM_API');
        }
    },
    
    methods: {
       
    }
    
}
</script>   

<style lang="scss">
  * { touch-action: manipulation; }
  html{scroll-behavior:smooth}
  /* скелет загрузки */
  .boot{position:fixed;inset:0;z-index:99999;background:#fff;overflow:hidden}
  .boot__cover{height:min(50vw,300px);max-width:1120px;margin:0 auto}
  .boot__id{display:flex;align-items:flex-end;gap:14px;max-width:1120px;margin:-30px auto 0;padding:0 16px}
  .boot__logo{width:72px;height:72px;border-radius:20px 20px 20px 6px;box-shadow:0 0 0 3px #fff}
  .boot__lines{flex:1;display:flex;flex-direction:column;gap:8px;padding-bottom:4px}
  .boot__lines i,.boot__grid i{display:block;height:14px;border-radius:7px}
  .boot__chips{display:flex;gap:8px;max-width:1120px;margin:18px auto 0;padding:0 16px}
  .boot__chips i{width:110px;height:32px;border-radius:999px}
  .boot__grid{display:grid;grid-template-columns:repeat(2,1fr);gap:22px 12px;max-width:1120px;margin:32px auto 0;padding:0 16px}
  .boot__grid div{display:flex;flex-direction:column;gap:8px}
  .boot__grid .boot__ph{height:auto;aspect-ratio:1/1;border-radius:18px 18px 18px 4px}
  @media (min-width:640px){.boot__grid{grid-template-columns:repeat(3,1fr)}}
  @media (min-width:1024px){.boot__grid{grid-template-columns:repeat(4,1fr)}}
  .sk{background:linear-gradient(100deg,#f4f5f8 30%,#e9ebf0 50%,#f4f5f8 70%) #f4f5f8;background-size:200% 100%;animation:sk 1.3s linear infinite}
  @keyframes sk{to{background-position:-200% 0}}

  /* «меню недоступно» и 404 */
  .state{position:fixed;inset:0;z-index:99999;background:#fff;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:10px;padding:24px;text-align:center;color:var(--y-ink-2)}
  .state h1{font-size:1.375rem;font-weight:700;letter-spacing:-.015em;color:var(--y-ink)}
  .state p{max-width:32ch;font-size:1rem;line-height:1.5}
  .state__ico{width:56px;height:56px;color:var(--y-ink-3);margin-bottom:6px}
  .state__code{font-size:4.5rem!important;font-weight:800;letter-spacing:-.05em;line-height:1;color:var(--y-ink)}
  .state__btn{margin-top:14px}
</style>



